import * as React from 'react';
import Header from '../../containers/MenuManager/Header';
import { Api } from '../../typings/api';
import { PageWrapper, TitleWrapper, VideoBackground } from './styles';
import Title from '../../containers/Title';
import PageBottomBar from './../../containers/Page/BottomBar';
import { DriveItemListOrigin } from '../../containers/DriveItemListPage/constants';
import SearchField from '../../containers/DriveItemList/Search/Field';
import { PageType } from '../../containers/Page/constants';

interface PageProps {
	children?: React.ReactNode;
	hasBottomBar?: boolean;
	pageType?: PageType;
	title?: string;
	driveItems?: Api.DriveItem[];
	showSearchField: boolean;
	origin: string;
	originParam: string;
	isScrollable?: boolean;
	backgroundUrl: string | undefined;
	backgroundColor: string | undefined;
	isVideoBackground: boolean;
}

const Page = ({
	children,
	driveItems,
	pageType,
	title,
	showSearchField,
	origin,
	originParam,
	hasBottomBar,
	isScrollable = true,
	backgroundUrl = '',
	backgroundColor = '',
	isVideoBackground,
}: PageProps) => (
	<>
		<Header driveItems={driveItems} />
		{showSearchField &&
			<SearchField
				searchText={origin === DriveItemListOrigin.Search ? originParam : ''}
			/>
		}
		<PageWrapper
			pageType={pageType}
			isScrollable={isScrollable}
			backgroundUrl={backgroundUrl}
			backgroundColor={backgroundColor}
			isVideoBackground={isVideoBackground}
			className="PageWrapper"
		>
			{isVideoBackground && pageType === PageType.DrivePage &&
				<VideoBackground
					key={backgroundUrl} // is needed to load a new video if page was changed
					autoPlay={true}
					playsInline={true}
					muted={true}
					loop={true}
				>
					<source src={backgroundUrl} type="video/mp4" />
				</VideoBackground>
			}
			{title &&
				<TitleWrapper className="TitleWrapper">
					<Title title={title} />
				</TitleWrapper>
			}
			{children}
		</PageWrapper>
		{hasBottomBar &&
			<PageBottomBar selection={driveItems || []} />
		}
	</>
);

export default Page;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Page/index.tsx